"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeEmailAddressRequestPayloadToJSON = exports.ChangeEmailAddressRequestPayloadFromJSONTyped = exports.ChangeEmailAddressRequestPayloadFromJSON = void 0;
var runtime_1 = require("../runtime");
function ChangeEmailAddressRequestPayloadFromJSON(json) {
    return ChangeEmailAddressRequestPayloadFromJSONTyped(json, false);
}
exports.ChangeEmailAddressRequestPayloadFromJSON = ChangeEmailAddressRequestPayloadFromJSON;
function ChangeEmailAddressRequestPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'newEmailAddress': json['newEmailAddress'],
        'newsletter': !(0, runtime_1.exists)(json, 'newsletter') ? undefined : json['newsletter'],
    };
}
exports.ChangeEmailAddressRequestPayloadFromJSONTyped = ChangeEmailAddressRequestPayloadFromJSONTyped;
function ChangeEmailAddressRequestPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'newEmailAddress': value.newEmailAddress,
        'newsletter': value.newsletter,
    };
}
exports.ChangeEmailAddressRequestPayloadToJSON = ChangeEmailAddressRequestPayloadToJSON;
//# sourceMappingURL=ChangeEmailAddressRequestPayload.js.map